import { AfterViewInit, Component, HostBinding, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CmsComponentData, ParagraphComponent as CxParagraphComponent } from '@spartacus/storefront';
import { fromEvent, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { CmsParagraphComponent } from '../../../core/model';

@Component({
  selector: 'py-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss'],
  providers: [{ provide: CxParagraphComponent, useClass: CxParagraphComponent }],
})
export class ParagraphComponent implements OnInit, OnDestroy, AfterViewInit {
  private subscriptions = new Subscription();

  constructor(
    public cmsComponent: CmsComponentData<CmsParagraphComponent>,
    protected router: Router,
    protected cxComponent: CxParagraphComponent, // NOTE: not extending due to inherited @HostListener('click') preventing text selection
    protected viewContainerRef: ViewContainerRef
  ) {}

  @HostBinding('class')
  hostClasses: string = '';

  ngOnInit(): void {
    this.cmsComponent.data$ = this.cmsComponent.data$.pipe(
      filter(Boolean),
      tap(({ styleClasses }) => {
        if (this.hasClass(styleClasses, 'flex-col-9')) {
          this.hostClasses = 'inline-75 d-lg-inline-block';
        }

        if (this.hasClass(styleClasses, 'flex-col-6')) {
          this.hostClasses = 'inline-50 d-lg-inline-block';
        }

        if (this.hasClass(styleClasses, 'flex-col-3')) {
          this.hostClasses = 'inline-25 d-lg-inline-block';
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit(): void {
    // Register the click handler in a non-Angular fashion, because Angular
    // won't let us select text if we register a click handler "the Angular way"
    this.subscriptions.add(
      fromEvent<MouseEvent>(this.viewContainerRef.element.nativeElement, 'click').subscribe((event) =>
        this.cxComponent.handleClick(event)
      )
    );
  }

  hasClass(styleClasses: string, type: string): boolean {
    return styleClasses?.split && styleClasses?.split(' ').includes(type);
  }

  public bypassSecurityTrustHtml(html: string = ''): SafeHtml {
    return this.cxComponent.bypassSecurityTrustHtml(html);
  }
}
